import React from "react";
import { Link } from "react-router-dom";
import { sendEvent } from "../../utils/gtag";

const RemoteTeamSection = () => {

  return (
    <section className="py-12 relative bg-gradient-to-tr from-[#264864] via-[#264864] to-[#35a89d] overflow-hidden">
      <div className="container mx-auto px-6 text-center relative z-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-4 leading-tight">
          Build Your Dream Team Remotely – Hire Experts On Demand
        </h2>
        <p className="text-base md:text-lg text-gray-100 mb-8 max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-2 font-light">
          <span className="font-semibold text-white whitespace-nowrap">
            ✓ No Monthly Salary
          </span>
          <span className="font-semibold text-white whitespace-nowrap">
            ✓ Fixed Amount
          </span>
          <span className="font-semibold text-white whitespace-nowrap">
            ✓ Project Base Contract
          </span>
          <span className="font-semibold text-white whitespace-nowrap">
            ✓ 24/7 Dedicated
          </span>
          <span className="font-semibold text-white whitespace-nowrap">
            ✓ Live Support
          </span>
        </p>

        {/* Button */}
        <Link
          to="/request-demo"
          onClick={() => sendEvent('request_demo')}
          className="dream-team-btn relative inline-flex items-center justify-center px-10 py-4 mb-2 overflow-hidden text-xl font-semibold text-white rounded-xl transition-all duration-300 transform hover:scale-110 border-transparent shadow-lg"
          style={{
            background: "linear-gradient(270deg, #264864, #35a89d)",
            backgroundSize: "200% 200%",
            animation: "gradientMove 6s ease infinite",
          }}
        >
          <span className="relative z-10 transition-all duration-300 text-white">
            Book a B2B Meeting
          </span>
        </Link>
      </div>

      {/* Thinner Gradient Border at Bottom */}
      <div
        className="absolute bottom-0 left-0 w-full h-[3px]"
        style={{
          background: "linear-gradient(270deg, #264864, #35a89d)",
          backgroundSize: "200% 200%",
          animation: "gradientMove 6s ease infinite",
        }}
      ></div>

      <style>{`
        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .dream-team-btn:hover {
          background: white !important;
          border-color: transparent;
          border-image: linear-gradient(270deg, #264864, #35a89d) 1;
        }

        .dream-team-btn:hover span {
          background: linear-gradient(270deg, #264864, #35a89d);
          background-size: 200% 200%;
          animation: gradientMove 6s ease infinite;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>
    </section>
  );
};

export default RemoteTeamSection;